import { mergeClassNames } from '@moniebook-web/utils';

import { UserDropdown } from '../user-dropdown';
import { SubmenuPanel } from './submenu-panel';
import type { SidebarMenuGroup } from './types';

interface IconRailPanelProps {
    groups: SidebarMenuGroup[];
    activeGroupId: string | null;
}

export function IconRailPanel({
    groups,
    activeGroupId,
}: Readonly<IconRailPanelProps>) {
    const activeGroup = activeGroupId
        ? groups.find((group) => group.id === activeGroupId)
        : null;

    return (
        <div
            className={mergeClassNames(
                'absolute top-0 bottom-0 left-48 h-full w-[202px] bg-background-sidebar-faded2',
                'flex flex-col border-ui-border-default border-r',
            )}>
            <div className='relative flex h-full min-w-0 flex-col'>
                <div className='sticky top-0 flex h-48 w-full min-w-0 shrink-0 items-center gap-8 bg-white px-12'>
                    <UserDropdown />
                </div>
                {activeGroup && <SubmenuPanel group={activeGroup} />}
            </div>
        </div>
    );
}
